import { render, staticRenderFns } from "./M2hContent.vue?vue&type=template&id=02c04426&scoped=true&"
import script from "./M2hContent.vue?vue&type=script&lang=js&"
export * from "./M2hContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c04426",
  null
  
)

export default component.exports